import React from 'react'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// context
import { ReportAPIContext } from 'containers/Report/layers/API'

const EnterFullScreenButton: React.FC = () => {
  const { enterFullscreen } = React.useContext(ReportAPIContext)

  return (
    <Button style={CREATE_BUTTON_STYLE} layout={BUTTON_LAYOUTS.DARK_BLUE} onClick={enterFullscreen}>
      Enter full screen
    </Button>
  )
}

export default EnterFullScreenButton
